import { createMakeStyles } from 'tss-react';
import { useTheme } from '@material-ui/core';

const { makeStyles } = createMakeStyles({ useTheme });

export const useStyles = makeStyles()(() => ({
  gridItem: {
    '& > *': {
      height: '100%',
    },
  },
}));
